// 获取测评题目
export const EVALUATION_GET_LIST = 'EVALUATION_GET_LIST';

// 设置测评题目
export const EVALUATION_SET_LIST = 'EVALUATION_SET_LIST';

// 获取测评的基础信息
export const EVALUATION_GET_INFO = 'EVALUATION_GET_INFO';

// 设置测评基础信息
export const EVALUATION_SET_INFO = 'EVALUATION_SET_INFO';

// 更新测评
export const EVALUATION_UPDATE_EVALUATION = 'EVALUATION_UPDATE_EVALUATION';

// 添加测评题目
export const EVALUATION_ADD_QUESTION = 'EVALUATION_ADD_QUESTION';

// 移除测评题目
export const EVALUATION_REMOVE_QUESTION = 'EVALUATION_REMOVE_QUESTION';

// 测评引用作业
export const EVALUATION_ADD_REFER = 'EVALUATION_ADD_REFER';

// 测评移除作业
export const EVALUATION_REMOVE_REFER = 'EVALUATION_REMOVE_REFER';

// 设置课程的信息
export const EVALUATION_SET_LESSON_INFO = 'EVALUATION_SET_LESSON_INFO';
//
export const EVALUATION_SET_CONTENT = 'EVALUATION_SET_CONTENT';

//
export const EVALUATION_SET_SELECT = 'EVALUATION_SET_SELECT';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_evaluation.js